'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _MatrixClientPeg = require('../../../MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _languageHandler = require('../../../languageHandler');

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _Modal = require('../../../Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _AccessibleButton = require('../elements/AccessibleButton');

var _AccessibleButton2 = _interopRequireDefault(_AccessibleButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2017 Vector Creations Ltd
Copyright 2019 Michael Telatynski <7t3chguy@gmail.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

module.exports = (0, _createReactClass2.default)({
    displayName: 'RoomAvatarEvent',

    propTypes: {
        /* the MatrixEvent to show */
        mxEvent: _propTypes2.default.object.isRequired
    },

    onAvatarClick: function onAvatarClick() {
        var cli = _MatrixClientPeg2.default.get();
        var ev = this.props.mxEvent;
        var httpUrl = cli.mxcUrlToHttp(ev.getContent().url);

        var room = cli.getRoom(this.props.mxEvent.getRoomId());
        var text = (0, _languageHandler._t)('%(senderDisplayName)s changed the avatar for %(roomName)s', {
            senderDisplayName: ev.sender && ev.sender.name ? ev.sender.name : ev.getSender(),
            roomName: room ? room.name : ''
        });

        var ImageView = _index2.default.getComponent("elements.ImageView");
        var params = {
            src: httpUrl,
            name: text
        };
        _Modal2.default.createDialog(ImageView, params, "mx_Dialog_lightbox");
    },

    render: function render() {
        var _this = this;

        var ev = this.props.mxEvent;
        var senderDisplayName = ev.sender && ev.sender.name ? ev.sender.name : ev.getSender();
        var RoomAvatar = _index2.default.getComponent("avatars.RoomAvatar");

        if (!ev.getContent().url || ev.getContent().url.trim().length === 0) {
            return _react2.default.createElement(
                'div',
                { className: 'mx_TextualEvent' },
                (0, _languageHandler._t)('%(senderDisplayName)s removed the room avatar.', { senderDisplayName: senderDisplayName })
            );
        }

        var room = _MatrixClientPeg2.default.get().getRoom(ev.getRoomId());
        // Provide all arguments to RoomAvatar via oobData because the avatar is historic
        var oobData = {
            avatarUrl: ev.getContent().url,
            name: room ? room.name : ""
        };

        return _react2.default.createElement(
            'div',
            { className: 'mx_RoomAvatarEvent' },
            (0, _languageHandler._t)('%(senderDisplayName)s changed the room avatar to <img/>', { senderDisplayName: senderDisplayName }, {
                'img': function img() {
                    return _react2.default.createElement(
                        _AccessibleButton2.default,
                        { key: 'avatar', className: 'mx_RoomAvatarEvent_avatar',
                            onClick: _this.onAvatarClick },
                        _react2.default.createElement(RoomAvatar, { width: 14, height: 14, oobData: oobData })
                    );
                }
            })
        );
    }
});
//# sourceMappingURL=RoomAvatarEvent.js.map